export default __webpack_public_path__ + "50df95a646d69a2032f46593ef9d1939.png";